import { render } from "./BreadCrumbs.vue?vue&type=template&id=05647856&scoped=true"
import script from "./BreadCrumbs.vue?vue&type=script&lang=js"
export * from "./BreadCrumbs.vue?vue&type=script&lang=js"

const cssModules = {}
import style0 from "./BreadCrumbs.vue?vue&type=style&index=0&id=05647856&lang=scss&module=true"
cssModules["$style"] = style0
import "./BreadCrumbs.vue?vue&type=style&index=1&id=05647856&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/prod-fe-app-myqampus/node_modules/vue-cli-plugin-vue-next/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__cssModules',cssModules],['__scopeId',"data-v-05647856"]])

export default __exports__